import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom'
import moment from 'moment';

const HistoryEvent = (props) => {
  return (
    <div className="inventory-history-item">
      <div className="d-flex col-md-3">
        <div className="mr-05"><i className="fa fa-calendar-check-o"></i></div>
        <div> {moment(props.temperature.date).format('LL')} </div>
      </div>
      <div className="col-md-9"><b className="mr-05">{props.temperature.value} ºF</b><span className="opacity-50">( by { props.temperature.user % 1 === 0 ? ' you' : props.temperature.user} )</span></div>
    </div>
  )
}

const HistoryEventsList = (props) => {
  if (props.temperatures.length >0) {
    return (
      <div>
      {props.temperatures.map((temp,index) => {
          return (
            <HistoryEvent temperature={temp} key={index}/>
          )
      })} </div>
    )
  } else {
    return null
  }
}

const LastHistoryEvent = (props) => {
  //
  // The Last event is the moment that the inventory item was removed from the inventory (or returned)
  // Last event could be: Shipped, Shipped and Returned, Used as ingredient or Deleted.
  let eventMessage = '',
      eventMessage2 = '',
      eventMessage3 = '',
      eventDate = '',
      eventDate2 = '',
      eventDate3 = '',
      eventNavLink = '',
      eventNavLink2 = '',
      eventNavLink3 = '',
      ByUser = '';

  // The inventory item was shipped:
  if (!props.inventory.active && props.inventory.shipment) {
    eventMessage = 'Shipped';
    eventDate = moment(props.inventory.shipment_date).format('LL');
    eventNavLink = `/shipment/${props.inventory.shipment}/`;

    // The inventory was shipped and returned too:
    if (props.inventory.returned) {
      eventMessage2 = 'Returned';
      eventDate2 = moment(props.inventory.returned_date).format('LL');
      eventNavLink2 = `/return/${props.inventory.returned}/`;

      // The inventory was shipped and returned too:
      if (props.inventory.credit_note) {
        eventMessage3 = 'Credit Note';
        eventDate3 = moment(props.inventory.credit_note.created_at).format('LL');
        eventNavLink3 = `/credit_note/${props.inventory.credit_note.id}/`;
      }
    }

    // The inventory item was shipped and received in market:
    if (props.inventory.received_date) {
      eventMessage = `Received in market (${props.inventory.received_with_scanner ? 'Scanned' : 'Manually'})`;
      eventDate = `${moment(props.inventory.received_date).format('LL')}`;
      eventNavLink = `/shipment/${props.inventory.shipment}/`;
    }

  // The inventory item was deleted:
  } else if (!props.inventory.active && (props.inventory.delete_message || props.inventory.waste_category)) {
    eventMessage = 'Removed from inventory';
    eventDate = moment(props.inventory.delete_date).format('LL')
    ByUser = `(by ${ props.inventory.delete_user % 1 === 0 ? ' you' : props.inventory.delete_user} )`;

  // The inventory item was used as ingredient:
  } else if (!props.inventory.active && props.inventory.session_ingredient) {
    eventMessage = 'Used as ingredient';
    eventDate = moment(props.inventory.session_ingredient.date_created).format('LL');
    eventNavLink = `/session/${props.inventory.session_ingredient.id}/`;

  // The inventory item was used as ingredient:
} else if (!props.inventory.active && props.inventory.credit_note) {
    eventMessage = 'Credit Note';
    eventDate = moment(props.inventory.credit_note.created_at).format('LL');
    eventNavLink = `/credit_note/${props.inventory.credit_note.id}/`;

  // The inventory item is still active (or there is no event to show):
  } else { return null }

  return (
    <div>
      <div className="inventory-history-item">
        <div className="d-flex col-md-3">
          <div className="mr-05"><i className="fa fa-calendar-check-o"></i></div>
          <div>{eventDate}</div>
        </div>
        <div className="col-md-9">
          { ByUser ?
            <span className="color-danger">
              <b className="mr-05">{eventMessage}</b><span className="opacity-50">{ByUser}</span>
            </span>
            :
            <NavLink to={eventNavLink}><b>{eventMessage}</b></NavLink>
          }
        </div>
      </div>
      { eventMessage2 ?
        <div className="inventory-history-item">
          <div className="d-flex col-md-3">
            <div className="mr-05"><i className="fa fa-calendar-check-o"></i></div>
            <div>{eventDate2}</div>
          </div>
          <div className="col-md-9">
            <NavLink to={eventNavLink2}><b>{eventMessage2}</b></NavLink>
          </div>
        </div>
      : null}
      { eventMessage3 ?
        <div className="inventory-history-item">
          <div className="d-flex col-md-3">
            <div className="mr-05"><i className="fa fa-calendar-check-o"></i></div>
            <div>{eventDate3}</div>
          </div>
          <div className="col-md-9">
            <NavLink to={eventNavLink3}><b>{eventMessage3}</b></NavLink>
          </div>
        </div>
      : null}
    </div>
  )
}

const FirstHistoryEvent = (props) => {
  //
  // The first event is the moment that the inventory item was added to the inventory
  // First event could be: Produced. Leftover, Received, Returned or Migrated (Old system data).
  let eventMessage = '',
      eventDate = '',
      eventNavLink = '',
      eventLink = '';

 // The inventory item was Received:
  if (props.inventory.invoice) {
    eventMessage = 'Received'
    eventDate = moment(props.inventory.date_created).format('LL')
    eventNavLink = `/invoice/${props.inventory.invoice.id}/`

  // The inventory item was Produced:
  } else if (props.inventory.session_product) {
    eventMessage = 'Produced'
    eventDate = moment(props.inventory.session_product.date_created).format('LL')
    eventNavLink = `/session/${props.inventory.session_product.id}/`

  // The inventory item was Leftover:
  } else if (props.inventory.session_leftover) {
    eventMessage = 'Leftover'
    eventDate = moment(props.inventory.session_leftover.date_created).format('LL')
    eventNavLink = `/session/${props.inventory.session_leftover.id}/`

  // The inventory item was Returned:
  } else if (props.inventory.from_shipment_return) {
      eventMessage = 'Shipment Return'
      eventDate = moment(props.inventory.from_shipment_return_date).format('LL')
      eventNavLink = `/return/${props.inventory.from_shipment_return}/`

      // The inventory item was taken from its parent
  } else if (props.inventory.parent) {
      eventMessage = 'Taken from parent inventory'
      eventDate = moment(props.inventory.creation_date).format('LL')
      eventLink = `/inventory/${props.inventory.parent}/`

  //  The inventory item was Migrated:
  } else {
    eventMessage = 'Old system data'
    eventDate = '-'
    eventNavLink = ''
  }

  return (
    <div className="inventory-history-item">
      <div className="d-flex col-md-3">
        <div className="mr-05"><i className="fa fa-calendar-check-o"></i></div>
        <div>{eventDate}  </div>
      </div>
      <div className="col-md-9">
        {eventNavLink ? <NavLink to={eventNavLink}><b>{eventMessage}</b></NavLink> :
          eventLink ? <a className='font-weight-bold' href={eventLink}>{eventMessage}</a> : <span><b>{eventMessage}</b></span>}
      </div>
    </div>
  )
}

export default class InventoryHistory extends Component {

  constructor(props) {
    super(props);
    this.state = { isOpened: true }
  }

  toggleCollapse = () => {
    this.setState({isOpened: !this.state.isOpened});
  };

  render() {
    return (
      <div className="mb-20">
        <div className="d-flex justify-content-between align-items-center card-header border-gray pointer" onClick={this.toggleCollapse}>
          <span className="mr-05"><b>History </b></span>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="inventory-timeline">
            <div className="inventory-history-list">
              <FirstHistoryEvent inventory={this.props.inventory}/>
              <HistoryEventsList temperatures={this.props.inventory.temperatures}/>
              <LastHistoryEvent inventory={this.props.inventory} />
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}
